import { AxiosResponse } from 'axios';
import Api from './api';

const LoginApi = (data: any): Promise<AxiosResponse> => {
  const path = '/login';
  return Api.getInstance().request.post(path, data);
};

export default LoginApi;
